import React, { useState, useEffect, useCallback } from "react";
import { Toast, Card } from "react-bootstrap";

import { useFormik } from "formik";
import  { useHistory } from 'react-router-dom'
import * as Yup from "yup";
import useAxiosInterceptors from "../../../../hooks/httpConfig";
// Validation schema avec Yup
const SignupSchema = Yup.object().shape({
  prenom: Yup.string().required("Le prénom est obligatoire"),
  nom: Yup.string().required("Le nom est obligatoire"),
  email: Yup.string()
    .email("Adresse e-mail invalide")
    .required("L'adresse e-mail est obligatoire"),
  password: Yup.string()
    .required("Le mot de passe est obligatoire")
    .min(8, "Le mot de passe doit contenir au moins 8 caractères")
    .matches(/[A-Z]/, "Le mot de passe doit contenir au moins une lettre majuscule")
    .matches(/[a-z]/, "Le mot de passe doit contenir au moins une lettre minuscule")
    .matches(/[0-9]/, "Le mot de passe doit contenir au moins un chiffre")
    .matches(/[!@#$%^&*(),.?":{}|<>]/, "Le mot de passe doit contenir au moins un caractère spécial"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Les mots de passe doivent correspondre")
    .required("La confirmation du mot de passe est obligatoire"),
  telephone: Yup.string()
    .required("Le numéro de téléphone est obligatoire")
    .matches(/^\d{10}$/, "Le numéro de téléphone doit comporter 10 chiffres"),
});

// const SignupSchema = Yup.object().shape({
//   nom: Yup.string().required("Le nom est obligatoire"),
//   prenom: Yup.string().required("Le prenom est obligatoire"),
//   // email: Yup.string().email("Email invalide").required("L'adresse e-mail est obligatoire")
//   // 	.test('unique email', 'already using', async (value) => {
//   // 	try {
//   // 	  const res = await axios.post('/accounts/emailcheck', { email: value });
//   // 	  return res.data.possible;
//   // 	} catch (err) {
//   // 	  console.error(err);
//   // 	}
//   //   }),
//   email: Yup.string()
//     .email("Email invalide")
//     .required("L'adresse e-mail est obligatoire"),
//   // .test("email", "Cet email a deja été utilisé", (email) => {
//   //   return new Promise((resolve, _reject) => {
//   //     checkUserExists({ email }).then(({ data }) => {
//   //       resolve(!data);
//   //     });
//   //   });
//   // })
//   password: Yup.string().required("Le mot de passe est obligatoire"),
//   telephone: Yup.string().required("Le mot de passe est obligatoire"),
// });

export function RegisterConfirm() {
  const [show, setShow] = useState(true);
  
  return (
    <Toast
      style={{
        position: "absolute",
        bottom: "1rem",
        right: "1rem",
      }}
      onClose={() => setShow(false)}
      show={show}
      delay={5000}
      bg="success"
    >
      <Toast.Header>
        <strong className="mr-auto">Bootstrap</strong>
        <small>11 mins ago</small>
      </Toast.Header>
      <Toast.Body>Woohoo, you're reading this text in a Toast!</Toast.Body>
    </Toast>
  );
}

const RegisterForm = () => {
  const [email, setEmail] = useState(null);
  const [registerConfirm, setRegisterConfirm] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState(null);
  const [registerError, setRegisterError] = useState(null);
  const [passwordRules, setPasswordRules] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false,
  });
  const axiosInstance = useAxiosInterceptors();
  const history = useHistory();
  useEffect(() => {}, [setEmail]);
  const formik = useFormik({
    initialValues: {
      nom: "",
      prenom: "",
      email: "",
      password: "",
      confirmPassword: "",
      telephone: "",
    },
    validationSchema: SignupSchema,
    onSubmit: (values) => {
      setRegisterError(null);
      const register = async (user) => {
        try {
          const res = await axiosInstance.post(`inscription`, user);
          if (res) {
            return res?.data;
          }
        } catch (error) {
          setRegisterError(
            error?.response?.data?.message || "Une erreur est survenue."
          );
          return;
        }
      };
      register(values).then((response) => {
        if (!response) return;
        setEmail(values.email);
        setRegisterConfirm(true);
      });
    },
  });
  const handleConfirmOtp = async (event) => {
    event.preventDefault();
    setOtpError(null);
    try {
      await axiosInstance.post(`confirmInscription`, { email, otp });
      history.push('/login');
    } catch (error) {
      setOtpError(
        error?.response?.data?.message || "Code invalide ou expiré."
      );
    }
  };
  const handleCancel = (event) => {
    console.log(event);
    setRegisterConfirm(false);
  };
  // Gestion de la validation dynamique des règles du mot de passe
  const handlePasswordChange = useCallback((value) => {
    setPasswordRules({
      length: value.length >= 8,
      uppercase: /[A-Z]/.test(value),
      lowercase: /[a-z]/.test(value),
      number: /[0-9]/.test(value),
      specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(value),
    });
  }, []);
  return (
    <>
      {/* LOGIN TITLE */}
      {!registerConfirm ? (
        <>
          <h3 className="LoginForm-Title">Inscrivez-vous !</h3>
          <form
            id="LoginForm"
            className="LoginForm"
            onSubmit={formik.handleSubmit}
          >
            {/* LOGIN INPUTS */}
            <div className="Input-Row">
              <i className="uil uil-user"></i>
              <input
                type="text"
                name="nom"
                id="nom"
                placeholder="Nom"
                className="DRInput-Class"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.nom}
              />
              {formik.touched.nom && formik.errors.nom ? (
                <div className="text-danger text-right">
                  {formik.errors.nom}
                </div>
              ) : null}
            </div>
            <div className="Input-Row">
              <i className="uil uil-user"></i>
              <input
                type="text"
                name="prenom"
                id="prenom"
                placeholder="Prenom"
                className="DRInput-Class"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.prenom}
              />
              {formik.touched.prenom && formik.errors.prenom ? (
                <div className="text-danger text-right">
                  {formik.errors.prenom}
                </div>
              ) : null}
            </div>
            <div className="Input-Row">
              <i className="uil uil-envelope"></i>
              <input
                type="text"
                name="email"
                id="email"
                placeholder="Adresse e-mail"
                className="DRInput-Class"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
              />
              {formik.touched.email && formik.errors.email ? (
                <div className="text-danger text-right">
                  {formik.errors.email}
                </div>
              ) : null}
            </div>
            <div className="Input-Row">
              <i className="uil uil-lock-alt"></i>
              <input
                type="password"
                name="password"
                id="password"
                placeholder="Mot de passe"
                className="DRInput-Class"
                onChange={(e) => {
                  formik.handleChange(e);
                  handlePasswordChange(e.target.value);
                }}
                // onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
              />
              {/* {formik.touched.password && formik.errors.password ? (
                <div className="text-danger text-right">
                  {formik.errors.password}
                </div>
              ) : null} */}
              <div>
                <ul className="mt-2">
                  <li style={{ color: formik.touched.password ? (passwordRules.length ? "green" : "red") : "black" }}>
                    Au moins 8 caractères
                  </li>
                  <li style={{ color: formik.touched.password ? (passwordRules.uppercase ? "green" : "red") : "black" }}>
                    Au moins une lettre majuscule
                  </li>
                  <li style={{ color: formik.touched.password ? (passwordRules.lowercase ? "green" : "red") : "black" }}>
                    Au moins une lettre minuscule
                  </li>
                  <li style={{ color: formik.touched.password ? (passwordRules.number ? "green" : "red") : "black" }}>
                    Au moins un chiffre
                  </li>
                  <li style={{ color: formik.touched.password ? (passwordRules.specialChar ? "green" : "red") : "black" }}>
                    Au moins un caractère spécial
                  </li>
                </ul>
              </div>
            </div>
            <div className="Input-Row">
              <i className="uil uil-lock-alt"></i>
              <input
                type="password"
                name="confirmPassword"
                id="confirmPassword"
                placeholder="Confirmation du mot de passe"
                className="DRInput-Class"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.confirmPassword}
              />
              {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
                <div className="text-danger text-right">
                  {formik.errors.confirmPassword}
                </div>
              ) : null}
            </div>
            <div className="Input-Row">
              <i className="uil uil-phone"></i>
              <input
                type="text"
                name="telephone"
                id="telephone"
                placeholder="Numéro de telephone"
                className="DRInput-Class"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.telephone}
              />
              {formik.touched.telephone && formik.errors.telephone ? (
                <div className="text-danger text-right">
                  {formik.errors.telephone}
                </div>
              ) : null}
            </div>
            {registerError ? (
              <div className="text-danger text-center">{registerError}</div>
            ) : null}
            {/* LOGIN SUBMIT */}
            <button
              type="submit"
              name="FormLogin-Submit"
              className="Form-Submit"
            >
              <i className="uil uil-user-check"></i> S'inscrire
            </button>
          </form>
        </>
      ) : (
        <Card>
          <Card.Body>
            <Card.Title className="LoginForm-Title">
              Votre inscription est bien enregistree
            </Card.Title>
            <Card.Text as="div">
              <p>
                {" "}
                Un e-mail automatique de confirmation vient d'etre envoye a
                votre adresse email : {email}{" "}
              </p>
              <p>
                L'adresse est incorrecte ? Corrigez-la en fermant cette fenetre
                et saisissait une nouvelle adresse.
              </p>
              <p>
                Vous ne retrouvez pas notre e-mail de confirmation? Merci de
                verifier si vous ne l'avez pas recu parmis vos "Spam".
              </p>
            </Card.Text>
            <form onSubmit={handleConfirmOtp}>
              <div className="Input-Row">
                <input
                  type="text"
                  name="otp"
                  id="otp"
                  placeholder="Code de vérification"
                  className="DRInput-Class"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                />
              </div>
              {otpError ? (
                <div className="text-danger text-right">{otpError}</div>
              ) : null}
              <Card.Link
                as="button"
                type="button"
                onClick={handleCancel}
                className="btn btn-danger"
              >
                Annuler
              </Card.Link>
              <Card.Link as="button" type="submit" className="btn btn-primary">
                Confirmer
              </Card.Link>
            </form>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default RegisterForm;
